import type { Components } from '@mui/material/styles';
import type { Theme } from '@mui/system';

export default function component<T extends keyof Components>(
  _key: T,
  props: Components<Theme>[T]
) {
  return props;
}
